import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function FAQ({ items, kicker = "Questions fréquentes", title }) {
    const [open, setOpen] = useState(0);

    return (
        <section data-testid="faq" className="bg-xv-ivory py-28 md:py-40">
            <div className="max-w-[1200px] mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-12 gap-12 mb-20">
                    <div className="lg:col-span-5">
                        <Reveal>
                            <div className="flex items-center gap-4 mb-8 text-xv-gold">
                                <span className="divider-gold" />
                                <span className="overline">{kicker}</span>
                            </div>
                            {title && (
                                <h2
                                    className="font-serif text-xv-black text-[36px] md:text-5xl lg:text-[56px] leading-[1.05]"
                                    style={{ fontWeight: 300 }}
                                >
                                    {title}
                                </h2>
                            )}
                        </Reveal>
                    </div>
                </div>

                <div className="border-t border-xv-line">
                    {items.map((item, i) => {
                        const isOpen = open === i;
                        return (
                            <Reveal key={item.q} delay={i * 0.04}>
                                <div
                                    data-testid={`faq-item-${i}`}
                                    className="border-b border-xv-line"
                                >
                                    <button
                                        type="button"
                                        data-testid={`faq-toggle-${i}`}
                                        onClick={() =>
                                            setOpen(isOpen ? -1 : i)
                                        }
                                        className="w-full flex items-start justify-between gap-8 py-8 md:py-10 text-left group"
                                    >
                                        <h3
                                            className="font-serif text-[20px] md:text-[26px] lg:text-[30px] text-xv-black leading-snug transition-colors duration-500 group-hover:text-xv-midnight"
                                            style={{ fontWeight: 400 }}
                                        >
                                            {item.q}
                                        </h3>
                                        <span className="shrink-0 mt-2 text-xv-gold">
                                            {isOpen ? (
                                                <Minus
                                                    strokeWidth={1.2}
                                                    size={22}
                                                />
                                            ) : (
                                                <Plus
                                                    strokeWidth={1.2}
                                                    size={22}
                                                />
                                            )}
                                        </span>
                                    </button>
                                    <div
                                        className={`overflow-hidden transition-[max-height] duration-700 ease-out ${
                                            isOpen ? "max-h-[600px]" : "max-h-0"
                                        }`}
                                    >
                                        <p className="pb-10 pr-8 text-xv-text-secondary text-[15px] md:text-[17px] leading-[1.9] font-light max-w-3xl">
                                            {item.a}
                                        </p>
                                    </div>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
